<script setup lang="ts">
import AppButton from '@/shared/ui/AppButton/index';
import AppIcon from '@/shared/ui/AppIcon/index';
import {
  FEEDBACKS_EMPTY_TITLE,
  FEEDBACKS_EMPTY_TEXT,
  FEEDBACKS_EMPTY_BUTTON,
} from '@/pages/lawyer/lib/feedbacksConstants';

withDefaults(defineProps<{ isShowButton?: boolean }>(), {
  isShowButton: true,
});

const emit = defineEmits<{ (e: 'click'): void }>();

const isMobile: boolean = useIsMobile();

const isHovered: Ref<boolean> = ref(false);

const hoverHandler = (): void => {
  isHovered.value = true;
};

const leaveHandler = (): void => {
  isHovered.value = false;
};

const clickHandler = (): void => {
  emit('click');
};
</script>

<template>
  <div
    :class="['feedbacks-empty-placeholder', { _mobile: isMobile, _hovered: isHovered }]"
    data-testid="feedbacks-empty-placeholder"
  >
    <AppIcon class="feedbacks-empty-placeholder__icon" name="StarSmile" />
    <div class="feedbacks-empty-placeholder__content">
      <div class="feedbacks-empty-placeholder__title">{{ FEEDBACKS_EMPTY_TITLE }}</div>
      <div class="feedbacks-empty-placeholder__text">{{ FEEDBACKS_EMPTY_TEXT }}</div>
    </div>
    <div
      v-if="isShowButton"
      class="feedbacks-empty-placeholder__button-wrapper"
      @mouseenter="hoverHandler"
      @mouseleave="leaveHandler"
      @touchstart.passive="hoverHandler"
      @touchend.passive="leaveHandler"
    >
      <AppButton
        class="feedbacks-empty-placeholder__button"
        is-bordered
        is-white
        :button-text="FEEDBACKS_EMPTY_BUTTON"
        right-icon-name="Pen"
        right-icon-width="15"
        right-icon-height="15"
        @click="clickHandler"
      />
    </div>
  </div>
</template>

<style lang="less">
.feedbacks-empty-placeholder {
  .flex-column(@size-x8);

  align-items: center;
  text-align: center;

  &__icon {
    width: 120px;
    height: 120px;

    path:not(:first-child) {
      opacity: 0;
      transition: opacity 0.3s;
    }

    path._sad {
      opacity: 1;
    }
  }

  &._hovered &__icon {
    path._sad {
      opacity: 0;
    }

    path._happy {
      opacity: 1;
    }
  }

  &__content {
    .flex-column(@size-x3);

    align-items: center;
  }

  &__title {
    font-size: @size-x6;
    font-weight: 700;
    line-height: 130%;
    max-width: 340px;
  }

  &__text {
    font-size: @size-x4;
    font-weight: 700;
    line-height: 130%;
    max-width: 340px;
    color: @color-silver-chalice;
  }

  & &__button {
    width: 300px;
  }

  &._mobile &__button {
    width: 100%;
    max-width: 300px;
  }
}
</style>
